// Botão de "criar novo registro" usado no topo das listagens -- mesmo
// visual do botão "Criar Ticket" em Ajuda (pílula com gradiente da marca,
// ícone + texto), em vez do antigo botão "+" sozinho.
import styled from "styled-components";

const CreateButton = styled.button`
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
  gap: 8px;
  padding: 9px 16px;
  border-radius: 10px;
  border: 1px solid transparent;
  background: var(--gradient-brand-soft);
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  box-shadow: var(--glow);
  transition: transform 0.18s ease, filter 0.18s ease;

  svg {
    flex-shrink: 0;
  }

  &:hover {
    filter: brightness(1.06);
    transform: translateY(-1px);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
    filter: none;
  }
`;

export default CreateButton;
